import { ReactElement } from 'react';
import { AiFillStar } from 'react-icons/ai';

const size: number = 28;

export const customIcons: {
    [index: string]: {
        icon: ReactElement;
    };
} = {
    0: {
        icon: <AiFillStar size={size} color='rgba(0, 0, 0, 0.26)' />,
    },
    1: {
        icon: <AiFillStar size={size} color='#F52426' />,
    },
    2: {
        icon: <AiFillStar size={size} color='#F72A2C' />,
    },
    3: {
        icon: <AiFillStar size={size} color= '#F93C3D' />,
    },
    4: {
        icon: <AiFillStar size={size} color='#F39015' />,
    },
    5: {
        icon: <AiFillStar size={size} color='#F59F34' />,
    },
    6: {
        icon: <AiFillStar size={size} color='#F8CA20' />,
    },
    7: {
        icon: <AiFillStar size={size} color='#F5C314' />,
    },
    8: {
        icon: <AiFillStar size={size} color= '#84CA20' />,
    },
    9: {
        icon: <AiFillStar size={size} color='#72B61B' />,
    },
    10: {
        icon: <AiFillStar size={size} color='#13C33E' />,
    },
    11: {
        icon: <AiFillStar size={size} color='#06981F' />,
    },
};

export const colors: string[] = [
    '#F52426',
    '#F72A2C',
    '#F93C3D',
    '#F39015',
    '#F59F34',
    '#F8CA20',
    '#F5C314',
    '#84CA20',
    '#72B61B',
    '#13C33E',
    '#06981F'
];
